
export default class TagFunctions {
  static evPagePush = (pageName, isProductPage = false, products = null) => {
    let today = new Date
    let weekday = new Array(7);
    weekday[0]="6";
    weekday[1]="0";
    weekday[2]="1";
    weekday[3]="2";
    weekday[4]="3";
    weekday[5]="4";
    weekday[6]="5";
    
      async function fetchCountryData() {
      try {
            let response = await fetch("https://ipapi.co/json/");
        if (response.ok) {
            let countryData = await response.json();
            return countryData.country_name
        } else {
          return 'NA'
        }
      } catch (error) {
        console.log('could not connect to service')
        return 'NA'
      }
    
      }
    function getCookie(cname) {
        let name = cname + "=";
        let decodedCookie = decodeURIComponent(document.cookie);
        let ca = decodedCookie.split(';');
        for(let i = 0; i <ca.length; i++) {
          let c = ca[i];
          while (c.charAt(0) == ' ') {
            c = c.substring(1);
          }
          if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
          }
        }
        return "";
      }
    async function sendData () {
      let country = await fetchCountryData()
         // if (getCookie('ageGate')) {
      if (isProductPage) {
        window.dataLayer.push({
          "event": "evPageView",
          "version": "1.0" , 
          "page": {
          "pageInfo": {
          "hostName": `${window.location.origin}`, 
          "pageName": pageName, 
          "currentURL": `${window.location.href}`,
          },
          },
          "user": {
              "profile": {
          "userWeekDay": weekday[today.getDay()],
          "userMonthDay": today.getDate().toString(), 
          "userMonth": (today.getMonth()+1).toString(), 
          "userTime": today.getHours().toString(), 
          "languajeUser": window.navigator.language.toLowerCase().startsWith('es') ? 'ESP' : 'ENG', 
          "profileInfo": {
          "ageUserBirthYear": getCookie('ageUserBirthYear')||'NA', 
          "ageUser":getCookie('ageUser')||'NA', 
          "ageUserCountry": country||'NA', 
          "userId": getCookie('userId')||'NA', 
          "email": getCookie('email')||'NA', 
          //"loginType": getCookie('loginType') 
          },
          "social": {
          "network": getCookie('network'), 
          },
          }
          },
          "products": products

          })
      } else window.dataLayer.push({
                  "event": "evPageView",
                  "version": "1.0" , 
                  "page": {
                  "pageInfo": {
                  "hostName": `${window.location.origin}`, 
                  "pageName": pageName, 
                  "currentURL": `${window.location.href}`,
                  },
                  },
                  "user": {
                      "profile": {
                  "userWeekDay": weekday[today.getDay()],
                  "userMonthDay": today.getDate().toString(), 
                  "userMonth": (today.getMonth()+1).toString(), 
                  "userTime": today.getHours().toString(), 
                  "languajeUser": window.navigator.language.toLowerCase().startsWith('es') ? 'ESP' : 'ENG', 
                  "profileInfo": {
                  "ageUserBirthYear": getCookie('ageUserBirthYear')||'NA', 
                  "ageUser":getCookie('ageUser')||'NA', 
                  "ageUserCountry": country||'NA', 
                  "userId": getCookie('userId')||'NA', 
                  "email": getCookie('email')||'NA', 
                  //"loginType": getCookie('loginType') 
                  },
                  "social": {
                  "network": getCookie('network'), 
                  },
                  }
                },
                  })
       //   }
    };
    sendData()
    }

  static evAgeGatePush = (action, error = 'NA') => {
      window.dataLayer.push({
        action: `${action}`,
        error: `${error}`,
        event: "evAgeGate"
      });
  };

  static evClickOptionsPush = action => {
    window.dataLayer.push({
      actionClick: `${action}`,
      event: "evClickOptions"
    });
  };

  static evSocialNetworkPush = (socialNetwork, action='Interaction') => {
    window.dataLayer.push({
      socialNetworkName: `${socialNetwork}`,
      actionSocialNetwork: `${action}`,
      event: "evSocialNetwork"
    });
  };

  static evib2cOutboundlinkPush = (name, type) => {
    window.dataLayer.push({
      nameOutboundLinkib2C: `${name}`,
      nameOutboundLinkTypeib2C: `${type}`,
      event: "evib2cOutboundlink"
    });
  };

  static evVideoPush = (name, action, quartile, totalTime, category) => {
    let minutes = Math.floor(totalTime / 60);
    let seconds = Math.floor(totalTime - minutes * 60);
    function str_pad_left(string,pad,length) {
      return (new Array(length+1).join(pad)+string).slice(-length);
  }
  
    let duration = str_pad_left(minutes, '0', 2) + ':' + str_pad_left(seconds, '0', 2);

     window.dataLayer.push({
      videoName: `${name}`,
      videoAction: `${action}`,
      videoQuartile: `${quartile}`,
      videoTotalTime: `${duration}`,
      videoCategory: `${category}`,
      event: "evVideoEvent"
    });
  };
}
